import { ArrowsClockwise, DownloadSimple, FolderSimple, SquaresFour } from 'phosphor-react';

export const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: SquaresFour },
  { key: 'format-converter', label: 'Format Converter', icon: ArrowsClockwise },
  { key: 'video-downloader', label: 'Video Downloader', icon: DownloadSimple },
  { key: 'storage', label: 'Storage', icon: FolderSimple }
];

export const PROJECTS = [
  {
    key: 'format-converter',
    name: 'Format Converter',
    description: 'Convert image and video files with cloud jobs, progress tracking, retries, and downloads.',
    logo: '/apps/format-converter/logo/logo.webp'
  },
  {
    key: 'video-downloader',
    name: 'Video Downloader',
    description: 'Queue URL-based video downloads and fetch processed files from cloud storage.',
    logo: '/apps/video-downloader/logo/logo.png'
  },
  {
    key: 'storage',
    name: 'Storage',
    description: 'Upload files, organize folders, and browse your personal cloud drive.',
    logo: '/apps/storage/logo/logo.png'
  }
];
